type Environment = "local" | "develop" | "live";

interface BackendEndpoints {
    chat: string;
    voice: string;
    liveapi?: string; /*                                */
    auth: string;
    pbkInitialMessages: string;
}

/*                                   */

export const CHAT_MESSAGES_LOCAL_STORAGE_KEY = "nucleus_chatbot_history";
export const FLOATING_BUTTON_LOCAL_STORAGE_KEY = "nucleus_chatbot_tooltip_closed";
export const FLOATING_BUTTON_DESCRIPTION_DELAY = 3000; /* */

/**
 *
 */
export const MAX_CHAT_HISTORY_AGE_DAYS = 14;
export const MAX_CHAT_HISTORY_AGE_MS = MAX_CHAT_HISTORY_AGE_DAYS * 24 * 60 * 60 * 1000;

export const VOICE_TOGGLETIP_LOCAL_STORAGE_KEY = "nucleus_voice_toggletip_closed";
export const VOICE_TOGGLETIP_DELAY = 3000; /* */

export const MIN_APP_VERSION_FOR_VOICE = {
    android: "13.41.0",
    ios: "11.52.0",
};
export const STORE_URLS = {
    android: "https:/*                                                            */
    ios: "https:/*                                                                         */
};

export const VOICE_AUDIO_CHUNK_SIZE = 1600; /*                                                               */

/*                 */

/**
 *
 *
 */
export const CHAT_CHARACTER_LIMIT = 350;

/**
 *
 *
 */
export const TYPEWRITER_ANIMATION_TOGGLE_KEY = "nucleus_chatbot_typewriter_animation";

/**
 *
 *
 */
export const ANDROID_AUTOFOCUS_TOGGLE_KEY = "nucleus_chatbot_android_autofocus";

/**
 *
 *
 */
export const PROMOTION_DEAL_IMAGE_URLS: string[] = import.meta.env.VITE_PROMOTION_DEAL_IMAGE_URLS?.split(",").filter(Boolean) || [
    "mpp360_323650_546679", /*                                     */
    "mpp360_323656_546677", /*                          */
    "mpp360_332094_577499", /*                                 */
];

/*   */

/**
 *
 *
 */
export const LOGIN_URL = import.meta.env.VITE_LOGIN_URL || "/customer-identity/login";

export const CHAT_URL = "/chat";

/**
 *
 */
const DEFAULT_BACKEND_ENDPOINTS: Record<Environment, BackendEndpoints> = {
    local: {
        chat: "ws:/*                           */
        voice: "ws:/*                                 */
        liveapi: "ws:/*                                        */
        auth: "http:/*                                */
        pbkInitialMessages: "http:/*                                                  */
    },
    develop: {
        chat: "wss:/*                                */
        voice: "wss:/*                                      */
        liveapi: "wss:/*                                             */
        auth: "/conversation/auth",
        pbkInitialMessages: "/conversation/initial-topic-messages",
    },
    live: {
        chat: "wss:/*                        */
        voice: "wss:/*                                     */
        auth: "/conversation/auth",
        pbkInitialMessages: "/conversation/initial-topic-messages",
    },
};

export const BACKEND_ENDPOINTS = getBackendEndpoints();
export const IS_LOCAL = detectEnvironment() === "local";

/**
 *
 */
function getBackendEndpoints(): BackendEndpoints {
    const env = detectEnvironment();

    return {
        chat: import.meta.env.VITE_BACKEND_URL || DEFAULT_BACKEND_ENDPOINTS[env].chat,
        voice: import.meta.env.VITE_VOICE_URL || DEFAULT_BACKEND_ENDPOINTS[env].voice,
        liveapi: import.meta.env.VITE_LIVEAPI_URL || DEFAULT_BACKEND_ENDPOINTS[env].liveapi,
        auth: import.meta.env.VITE_AUTH_URL || DEFAULT_BACKEND_ENDPOINTS[env].auth,
        pbkInitialMessages: import.meta.env.VITE_PBK_INITIAL_MESSAGES_URL || DEFAULT_BACKEND_ENDPOINTS[env].pbkInitialMessages,
    };
}

/**
 *
 */
function detectEnvironment(): Environment {
    let hostname = "localhost";
    try {
        hostname = location.hostname;
    } catch (e) {
        /*                                                     */
        return "local";
    }

    if (hostname === "www.otto.de") return "live";
    if (hostname === "develop.otto.de") return "develop";
    if (hostname.includes("localhost")) return "local";

    console.warn(`Unknown environment: ${hostname}. Defaulting to 'develop'.`);
    return "develop";
}
